import { ShipmentStatus } from '#/shared/api/generated/shipment/models'
import type { ShipmentDetail } from '#/shared/api/generated/shipment/models'

const NON_ARCHIVABLE_STATUSES = new Set<string>([ShipmentStatus.posted])

export function canArchiveShipment(
  shipment: ShipmentDetail | undefined,
): boolean {
  if (!shipment) return false
  return !NON_ARCHIVABLE_STATUSES.has(shipment.status)
}
